import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/analytics/topic-discovery')({
  head: () => ({
    meta: [{ title: 'Topic Discovery | Tekst' }],
  }),
  component: () => <Outlet />,
});
